import { gql } from '@apollo/client'

export const CountryFragment = gql`
  fragment CountryFragment on CountryNode {
    id
    code
    name
    euVatId
  }
`
export const COUNTRY_LIST_QUERY = gql`
  query Countries {
    countries {
      edges {
        node {
          ...CountryFragment
        }
      }
    }
  }
  ${CountryFragment}
`

export const RECOMMEND_TAX_RATE_QUERY = gql`
  query RecommendTaxRate($cpCountryId: String!, $vatIdEntered: Boolean) {
    recommendTaxRate(cpCountryId: $cpCountryId, vatIdEntered: $vatIdEntered)
  }
`
